var map = {
	"./yibiao0.png": "coJc",
	"./yibiao1.png": "lBLC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B9+J";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/yibiao.*\.png$
// module id = B9+J
// module chunks = 3